import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "antd";
// Mirrors the real transactions layout: a compact KPI strip, the chart block,
// then a few table rows — so the loading state doesn't jump on data arrival.
const TransactionsSkeleton = ()=>/*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-affiliate-metrics",
                children: Array.from({
                    length: 5
                }).map((_, index)=>/*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-affiliate-metric",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 72,
                                    minWidth: 72,
                                    height: 12
                                }
                            }),
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 56,
                                    minWidth: 56,
                                    height: 22
                                }
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ _jsx(Skeleton.Button, {
                active: true,
                block: true,
                style: {
                    height: 320
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    marginTop: 24
                },
                children: /*#__PURE__*/ _jsx(Skeleton, {
                    active: true,
                    title: false,
                    paragraph: {
                        rows: 4
                    }
                })
            })
        ]
    });
export { TransactionsSkeleton };
